const data = [
  {
    title: 'My Blog',
    image: '/images/projects/blog.png',
    link: 'https://blog.leodong.me',
  },
];

export default data;
